// Mirrors mobile_frontend/lib/fees.ts. The static fallback matches the
// backend defaults (1.1% / 7.1% + 2.9% processing + 30 cents).
export const FALLBACK_FEE_SCHEDULE = { oneTimePercent: 4, roundupPercent: 10, fixedCents: 30 }

/** 3.9 -> "3.9", 4 -> "4", 12.899999 -> "12.9" (at most 2 decimals, trailing zeros trimmed). */
export function formatPercent(p) {
  return String(parseFloat(p.toFixed(2)))
}

export function formatFeeLine(percent, fixedCents, name) {
  return `Claritas keeps ${formatPercent(percent)}% + $${(fixedCents / 100).toFixed(2)} of each gift to cover card processing and run the platform. The rest goes to ${name}.`
}
